import { useState } from 'react'
import { Menu, X, ShoppingCart, ClipboardList } from 'lucide-react'
import { SegmentedToggle } from './SegmentedToggle'
import { STORE_NAME } from '../config'

function Logo() {
  return (
    <div className="flex items-center gap-2">
      <svg
        className="h-9 w-9 text-brand-gold"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <circle cx="24" cy="24" r="22" stroke="currentColor" strokeWidth="2.5" />
        <path
          d="M14 28c0-6 4-10 10-10s10 4 10 10"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <rect x="10" y="20" width="28" height="10" rx="2" stroke="currentColor" strokeWidth="2.5" />
        <path d="M18 30v6M30 30v6" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
      </svg>
      <div className="hidden leading-tight sm:block">
        <span className="font-display block text-lg font-bold text-white">Alpha</span>
        <span className="block text-[10px] tracking-[0.2em] text-brand-gold-light">IMPORT EXPORT</span>
      </div>
    </div>
  )
}

export function Header({
  segment,
  onSegmentChange,
  onNavigate,
  cartCount,
  inquiryCount,
  onOpenCart,
  onOpenInquiry
}) {
  const [mobileOpen, setMobileOpen] = useState(false)

  const navLinks = [
    { label: 'Home', view: 'home' },
    { label: 'Categories', view: 'categories' },
    { label: 'Catalog', view: 'catalog' },
    { label: 'About', view: 'about' },
    { label: 'Who we are', view: 'who-we-are' },
    { label: 'Contact', view: 'contact' }
  ]

  return (
    <header className="sticky top-0 z-40 border-b border-white/10 bg-brand-navy shadow-sticky">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <button onClick={() => onNavigate('home')} className="-ml-1 p-1">
          <Logo />
        </button>

        <nav className="hidden items-center gap-8 md:flex">
          {navLinks.map((link) => (
            <button
              key={link.view}
              onClick={() => onNavigate(link.view)}
              className="menu-link text-sm font-medium"
            >
              {link.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3 sm:gap-4">
          <SegmentedToggle segment={segment} onChange={onSegmentChange} />

          <button
            onClick={onOpenCart}
            className="relative rounded-full p-2 text-white/80 transition-all duration-200 hover:bg-brand-gold hover:text-brand-navy"
            aria-label={segment === 'retail' ? 'Open cart' : 'Cart not available in wholesale'}
            disabled={segment !== 'retail'}
          >
            <ShoppingCart className="h-5 w-5" />
            {segment === 'retail' && cartCount > 0 && (
              <span className="absolute -right-1 -top-1 flex h-4 w-4 items-center justify-center rounded-full bg-brand-gold text-[10px] font-bold text-brand-navy">
                {cartCount}
              </span>
            )}
          </button>

          <button
            onClick={onOpenInquiry}
            className="relative rounded-full p-2 text-white/80 transition-all duration-200 hover:bg-brand-gold hover:text-brand-navy"
            aria-label={segment === 'wholesale' ? 'Open inquiry list' : 'Inquiry not available in retail'}
            disabled={segment !== 'wholesale'}
          >
            <ClipboardList className="h-5 w-5" />
            {segment === 'wholesale' && inquiryCount > 0 && (
              <span className="absolute -right-1 -top-1 flex h-4 w-4 items-center justify-center rounded-full bg-brand-gold text-[10px] font-bold text-brand-navy">
                {inquiryCount}
              </span>
            )}
          </button>

          <button
            className="rounded-full p-2 text-white/90 md:hidden"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            {mobileOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="border-t border-white/10 bg-brand-ocean px-4 py-4 md:hidden">
          {navLinks.map((link) => (
            <button
              key={link.view}
              onClick={() => {
                onNavigate(link.view)
                setMobileOpen(false)
              }}
              className="block w-full rounded-lg py-3 px-3 text-left text-sm font-medium text-white/75 transition-colors hover:bg-brand-gold hover:text-brand-navy"
            >
              {link.label}
            </button>
          ))}
        </div>
      )}
    </header>
  )
}
